// src/theme.js
// Shared design tokens, overlay config & social links

import templeOverlay from "../assets/temple-overlay.png";

// ---- COLORS / PALETTE (shared with Gallery) ----
export const palette = {
  bg: "#FFF8F0",       // warm cream (page background)
  ink: "#241B18",      // deep coffee brown (primary text)
  sub: "#5B4B45",      // muted warm brown-grey (secondary text)
  gold: "#D9A441",     // brass / temple lamp gold
  railLine: "#E4CFAF", // sandalwood border lines
  blush: "#FFF1E3",    // soft halwa / ghee tint
};

// ---- TYPOGRAPHY ----
export const fonts = {
  heading:
    '"Playfair Display", ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
  body:
    'Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji"',
};

// ---- OVERLAY / GRADIENT PATTERN (same as Gallery.jsx) ----
// Use this for full-page or full-section temple overlay backgrounds.
export const overlay = {
  image: templeOverlay,
  baseColor: palette.bg,
  // Spread this into a style prop: style={overlay.style}
  style: {
    backgroundColor: palette.bg,
    backgroundImage: `url(${templeOverlay})`,
    backgroundSize: "cover",       // full-page / full-section coverage
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    opacity: 0.18,                 // subtle, embossed look
    mixBlendMode: "overlay",
  },
};

// ---- SOCIAL LINKS CONFIG ----
export const socialLinks = [
  {
    id: "instagram",
    label: "Visit our Instagram",
    url: "https://instagram.com/",
    icon: "https://cdn-icons-png.flaticon.com/512/174/174855.png",
  },
  {
    id: "facebook",
    label: "Visit our Facebook",
    url: "https://facebook.com/",
    icon: "https://cdn-icons-png.flaticon.com/512/733/733547.png",
  },
  {
    id: "twitter",
    label: "Visit our Twitter",
    url: "https://twitter.com/",
    icon: "https://cdn-icons-png.flaticon.com/512/5968/5968830.png",
  },
];
